import { tint } from '@/lib/paper'
import { portraitUrl } from '@/lib/tree'
import { cn } from '@/lib/utils'

// Small shapes for the family's things: soft pebbles for spaces, and initials for people. Everything here takes its
// colors from the theme.

// Soft, uneven circles, so no two spaces look stamped from the same mould.
const shapes = [
  'rounded-[58%_42%_52%_48%/46%_56%_44%_54%]',
  'rounded-[44%_56%_46%_54%/55%_45%_55%_45%]',
  'rounded-[52%_48%_40%_60%/48%_58%_42%_52%]',
  'rounded-[47%_53%_57%_43%/52%_44%_56%_48%]',
  'rounded-[55%_45%_49%_51%/43%_53%_47%_57%]',
  'rounded-[42%_58%_54%_46%/50%_46%_54%_50%]',
]

// A space's mark: a pebble in one of the theme's tints, or a photo showing through the shape.
export function Pebble({ index, photo, className }: { index: number; photo?: string | null; className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={cn('block overflow-hidden', shapes[index % shapes.length], tint(index), className)}
    >
      {photo && <img src={photo} alt="" loading="lazy" decoding="async" className="size-full object-cover" />}
    </span>
  )
}

// Someone with an account, in a small circle beside their name: their portrait from the tree when there is one,
// otherwise their initial.
export function Initial({
  name,
  portrait,
  index = 1,
  className,
}: {
  name: string
  portrait?: string | null
  index?: number
  className?: string
}) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        'grid size-9 shrink-0 place-items-center overflow-hidden rounded-full text-sm font-semibold text-foreground',
        tint(index),
        className,
      )}
    >
      {portrait ? (
        <img src={portraitUrl(portrait, 'thumb')} alt="" decoding="async" className="size-full object-cover" />
      ) : (
        name.trim().charAt(0).toUpperCase()
      )}
    </span>
  )
}
